import {
  CreditCardItem,
  type CreditCardItemConstructor,
} from '../CreditCardItem'
import {
  type ReconcileMatchStatus,
  ReconcileMatchStatuses,
} from '../enums/ReconcileMatchStatusEnum'
import { StatementItem, type StatementItemConstructor } from '../StatementItem'

export interface ReconcileMatchConstructor {
  id: number
  status: ReconcileMatchStatus
  amount: string // decimal string — matched total
  creditcardItems: CreditCardItemConstructor[]
  statementItems: StatementItemConstructor[]
}

export class ReconcileMatch {
  readonly id: number
  readonly status: ReconcileMatchStatus
  readonly amount: string
  readonly creditcardItems: CreditCardItem[]
  readonly statementItems: StatementItem[]

  constructor(data: ReconcileMatchConstructor) {
    this.id = data.id
    this.status = data.status
    this.amount = data.amount
    this.creditcardItems = data.creditcardItems.map(
      (item) => new CreditCardItem(item)
    )
    this.statementItems = data.statementItems.map(
      (item) => new StatementItem(item)
    )
  }

  // Only CONFIRMED matches show on the Matched tab / bill table (BHV-039)
  get isConfirmed(): boolean {
    return this.status === ReconcileMatchStatuses.CONFIRMED
  }

  // "# of matches" column on the bill matched-items table (BHV-050)
  get statementItemCount(): number {
    return this.statementItems.length
  }

  get amountValue(): number {
    return parseFloat(this.amount)
  }
}
